// extracted by mini-css-extract-plugin
export default {"segmentedControl":"DailyworkParamsFeature_segmentedControl__swoY9"};